export enum AccountTabEnum {
  User = 'tabUser',
  Register = 'tabRegister',
}

export const isValidAccountTab = (value: unknown): value is AccountTabEnum => {
  return Object.values(AccountTabEnum).includes(value as AccountTabEnum);
};

export const getAccountTab = (value: unknown): AccountTabEnum | undefined => {
  if (isValidAccountTab(value)) {
    return value;
  }

  return undefined;
};
